export const maxEmailLength = 50;
